import * as React from 'react';
import { Outlet } from "react-router-dom";
import classes from './NavigationModulos.module.css';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer'
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import LogoutIcon from '@mui/icons-material/Logout';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import { useContext } from "react";
import { ContextSession } from '../services/ContextSession';
import { useState, useEffect } from 'react';
import logo from '../../src/modules/pagina inicio/images/2Digital.png'
import Slide from '@mui/material/Slide';
import Divider from '@mui/material/Divider';
import { Link, Dialog, DialogTitle, DialogActions, Tooltip } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Button, createTheme, List, useMediaQuery } from '@mui/material';
import { ThemeProvider } from '@emotion/react';
import Grid from '@mui/material/Grid';
import DataMenu from './Menu';
import PhoneIcon from '@mui/icons-material/Call';
import Lottie from 'react-lottie-player';
import mouse from '../../src/modules/pagina inicio/images/MouseAnimation.json'
import themas from '../styles/themas';
const drawerWidth = 240;
const SHOW_REVALORIZACION_MENU = false;

const isActivo = (estado = "") => ["ACTIVO", "Activo", "activo"].includes(estado);

const isJubiladoOPensionado = (estado = "") =>
  [
    "JUBILADO",
    "Jubilado",
    "jubilado",
    "PENSIONADO",
    "Pensionado",
    "pensionado",
  ].includes(estado);

function shouldShowSubmenuItem(submenuItem, estado) {
  const route = submenuItem?.[0];

  if (route === "Cotizaciones") {
    return isActivo(estado);
  }

  if (route === "Revalorizacion") {
    return SHOW_REVALORIZACION_MENU && isJubiladoOPensionado(estado);
  }

  return true;
}

function filterMenuByParticipantStatus(menu = [], estado = "") {
  return menu
    .map((menuItem) => {
      const parent = Array.isArray(menuItem[0]) ? [...menuItem[0]] : menuItem[0];
      const submenus = Array.isArray(menuItem[1])
        ? menuItem[1]
            .filter((submenuItem) => shouldShowSubmenuItem(submenuItem, estado))
            .map((submenuItem) => [...submenuItem])
        : undefined;

      return submenus ? [parent, submenus] : [parent];
    })
    .filter((menuItem) => !Array.isArray(menuItem[1]) || menuItem[1].length > 0);
}

const AppbarStyles = {
  appBar: {
    backgroundColor: 'var(--color-brand-primary)',
  },
  iconButton: {
    color: 'var(--color-white)',
  },
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const primary = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: themas.colors['brand-primary'],
    },
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "var(--color-surface-soft)",
          fontWeight: "900",
          boxSizing: "border-box",
          width: drawerWidth
        }
      }
    }
  }
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 20),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));


export default function MiniDrawer() {

  let sessi = useContext(ContextSession);
  const getFilteredMenu = React.useCallback(
    () => filterMenuByParticipantStatus(sessi.getMenu(), sessi.sessionData.estado),
    [sessi, sessi.sessionData.estado]
  );
  const [menu, setMenu] = React.useState(() => getFilteredMenu());
  const [mostar, setMostar] = React.useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = React.useState(false); // Estado para el menú hamburguesa en dispositivos móviles
  const isMobile = useMediaQuery('(max-width:820px)'); // Detectar si es una pantalla móvil
  // Obtener la hora actual
  const currentHour = new Date().getHours();

  // Determinar el saludo adecuado
  const greeting = currentHour < 12 ? "Buenos Días" : (currentHour < 18 ? "Buenas Tardes" : "Buenas Noches");

  const { sessionData } = useContext(ContextSession);
  const [token] = useState("0");

  useEffect(() => {
    setMenu(getFilteredMenu());
  }, [getFilteredMenu]);

  useEffect(() => {

    const handleBeforeUnload = (event) => {


      let token = sessi.getToken();

      //console.log("APP MAIN VAMOS A SALIR",token,token.length,"data clase",JSON.stringify(sessi.sessionData));
      if (token !== "" && token !== 0 && token !== "NA") sessi.storeAuthData();

      //event.preventDefault();
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    let data = JSON.parse(sessi.getDataST());
    let token = sessi.getToken();

    let localpath = sessi.sessionData.path;



    //console.log("VAMOS A CHEKEAR TOKEN!!", token, token.length);

    //console.log("DATA GUARDADA EN LOCALSTORAGE", data);

    if (token.length > 2) {
      //  sessi.storeAuthData();
    } else if (data != null)
      if (data.token.length > 2 && data.token !== "NA") {
        sessi.setDataAuth(data);
        localpath = data.path;
        // console.log("Vamos a confirmar inicio primero", sessi.sessionData.cambiarPw);
        if (sessi.sessionData.cambiarPw === 0) {
          navigate('/CambioClave');
        } else {
          navigate(localpath === undefined || localpath === "" ? '/Empleados' : localpath);
        }

        setMenu(() => "");
        setMenu(() =>
          filterMenuByParticipantStatus(sessi.getMenu(), sessi.sessionData.estado)
        );

      } else if ((token === "0" || token === 0 || token === "NA") && (token.length === 2 || token.length === 0)) {
        //console.log("LLEGO HASTA EL TOKEN ", token)
        navigate('/');
      }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [token]);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    sessi.clearSession();
    // Borrar localStorage
    localStorage.clear();
    sessi.setVariable("AbrirAgradecimiento", true)
    navigate('/Login');
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
    // Si el drawer se cierra en la versión móvil, cambiar el estado de los submenús a cerrados
    if (isMobile && !mobileOpen) {
      setMenu(prevMenu => prevMenu.map(submenu => {
        submenu[0][6] = false;
        return submenu;
      }));
    }
  };

  function handleMenu(x, y) {

    setMenu((men) => {
      men[x][0][y] = !men[x][0][y]
      return men;
    });
    setMostar((mos) => !mos);

    //console.log(menu);
  }


  return (
    <ThemeProvider theme={primary}>
      <Box sx={{ display: 'flex' }}>

        <CssBaseline />
        {isMobile && ( // Renderizar AppBar solo en pantallas móviles
          //AppBar Móviles
          <AppBar position="fixed" sx={AppbarStyles.appBar}>
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  color="default"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{ mr: 2, ...AppbarStyles.iconButton }}
                >
                  {mobileOpen ? <CloseIcon /> : <MenuIcon />}
                </IconButton>
                <Grid item md={2.2} >
                  <Box display="flex" alignItems="center">
                    <Lottie
                      loop
                      animationData={mouse}
                      play
                      style={{ width: '15%', height: 'auto' }}
                    />
                    <Grid item md={2.2} style={{ display: 'flex', alignItems: 'center', marginLeft: 5 }}>
                      <img style={{ width: 150, height: 'auto' }} src={logo} alt="Logo" />
                    </Grid>
                  </Box>
                </Grid>
              </Box>
              <Link
                href="#"
                onClick={() => {
                  handleOpen();
                }}
                sx={{
                  color: 'var(--color-white)',
                  display: 'flex',
                  alignItems: 'center',
                  '&:hover': {
                    color: 'var(--color-white)',
                  },
                  '&:hover svg': {
                    color: 'var(--color-white)',
                  },
                }}
              >
                <Tooltip title="Cerrar Sesión">
                  <LogoutIcon sx={{ ml: 1 }} />
                </Tooltip>
              </Link>
            </Toolbar>
          </AppBar>
        )}

        {/*AppBar Web*/}
        {!isMobile && (
          <AppBar color='primary' position="fixed" sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            '& *': { color: 'var(--color-white)' } // Agrega este estilo
          }}>
            <Toolbar style={{ height: '100px' }}>
              <Grid
                container
                spacing={{ xs: 2, md: 0 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                justifyContent="space-between"
                alignItems="center"
              >
                <Box display="flex" alignItems="center">
                  <Lottie
                    loop
                    animationData={mouse}
                    play
                    style={{ width: '20%', height: 'auto' }}
                  />
                  <Grid item md={2.2} style={{ display: 'flex', alignItems: 'center', marginLeft: 5 }}>
                    <img style={{ width: 180, height: 'auto' }} src={logo} alt="Logo" />
                  </Grid>
                </Box>

                <Grid item md={6} container justifyContent="center" alignItems="center">
                  <div style={{ textAlign: 'center' }}>
                    <h5 style={{ marginBottom: "0" }}>{greeting}, {sessionData.nombre}</h5>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <PhoneIcon style={{ color: 'var(--color-white)', marginRight: '8px', fontSize: '26px' }} />
                      <Link href="tel:+50422901900" style={{ margin: 0 }} sx={{
                        color: 'var(--color-white)',
                        display: 'flex',
                        alignItems: 'center',
                        '&:hover': {
                          color: 'var(--color-white)',
                        },
                        '&:hover svg': {
                          color: 'var(--color-white)',
                        },
                      }}>
                        +504 2290-1900
                      </Link>
                    </div>
                  </div>
                </Grid>
                <Grid item>
                  <Link
                    href="#"
                    onClick={() => {
                      handleOpen();
                    }}
                    sx={{
                      color: 'var(--color-white)',
                      display: 'flex',
                      alignItems: 'center',
                      '&:hover': {
                        color: 'var(--color-white)',
                      },
                      '&:hover svg': {
                        color: 'var(--color-white)',
                      },
                    }}
                  >
                    Cerrar Sesión{/*sessi.sessionData.usuario*/}
                    <Tooltip title="Cerrar Sesión">

                      <LogoutIcon sx={{ ml: 1 }} />
                    </Tooltip>

                  </Link>
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
        )}

        <Drawer
          variant={isMobile ? "temporary" : "permanent"} // Cambiar variant basado en si es móvil o no
          open={isMobile ? mobileOpen : true} // Abre el drawer solo en móviles cuando se activa el menú hamburguesa
          onClose={handleDrawerToggle}
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
            display: 'flex',
            flexDirection: 'column', // Asegura que los elementos se apilen verticalmente
          }}
          ModalProps={{
            keepMounted: true,
          }}
        >
          {isMobile && (
            <>
              <Grid item md={2.2} style={{ backgroundColor: "var(--color-brand-primary)", height: 120, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                <Box display="flex" alignItems="center">
                  <Lottie
                    loop
                    animationData={mouse}
                    play
                    style={{ width: '20%', height: 'auto' }}
                  />
                  <Grid item md={2.2} style={{ display: 'flex', alignItems: 'center', marginLeft: 5 }}>
                    <img style={{ width: 180, height: 'auto' }} src={logo} alt="Logo" />
                  </Grid>
                </Box>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <PhoneIcon style={{ color: 'var(--color-white)', marginRight: '4px', fontSize: '20px' }} />
                  <a
                    href="tel:+50422901900"
                    style={{
                      textDecoration: 'none',
                      color: 'var(--color-white)',
                      fontSize: 12,
                      fontFamily: 'Arial, sans-serif',
                      fontWeight: 300
                    }}
                  >
                    Soporte: +504 2290-1900
                  </a>
                </div>

              </Grid>
            </>
          )}
          <Divider />
          {!isMobile && (
            <Toolbar style={{ marginTop: 25 }} />
          )}
          <Box sx={{ overflow: 'auto', flexGrow: 1 }}>
            <Divider />
            <List className={classes.menuItem}>
              {menu.map((menu, index) => (
                <DataMenu key={index} x={index} mos={mostar} text={menu} submenu={handleMenu} cerrar={handleDrawerToggle} />
              ))}
            </List>
          </Box>
          {isMobile && (
            <>
              <Box sx={{ alignSelf: 'flex-end', margin: '10px' }}>
                <Button
                  onClick={handleOpen}
                  fullWidth
                  endIcon={<LogoutIcon style={{ color: 'var(--color-black)' }} />}
                  sx={{ transform: 'translateX(-20%)', color: 'var(--color-black)' }}
                >
                  Cerrar Sesión
                </Button>
              </Box>
            </>
          )}
        </Drawer>


        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <DrawerHeader />
          <main className={classes.main}>
            <Outlet />
          </main>
        </Box>
      </Box>
      <Dialog open={open} onClose={handleClose} TransitionComponent={Transition}>
        <DialogTitle>{"¿Está seguro que desea cerrar la sesión?"}</DialogTitle>

        <DialogActions>
          <Button onClick={handleClose} variant='contained' startIcon={<CloseIcon />} style={{ backgroundColor: 'var(--color-brand-secondary)' }}>
            No
          </Button>
          <Button onClick={handleLogout} variant='contained' endIcon={<LogoutIcon />} style={{ backgroundColor: 'var(--color-brand-primary)' }}>
            Si
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}

